module.exports = __webpack_public_path__ + "img/牡丹皮.8651a83c.jpg";